import script from "./BaseStages.vue?vue&type=script&lang=ts"
export * from "./BaseStages.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__